import { App } from '@vue/runtime-core'

export default {
  install: (app:App) :void => {
    app.directive('position', {
      created(el) {
        el.style.visibility = 'hidden'
        el.style.position = 'fixed'
      },
      mounted(el) {
        el.dataset.display = document?.defaultView?.getComputedStyle(el, null).display
      },
      updated(el, binding) {
        const { value } = binding
        el.style.visibility = 'unset'
        el.style.position = 'fixed'

        if (!value) {
          el.style.display = 'none'
        } else {
          let x = value.x
          let y = value.y
          el.style.display = el.dataset.display
          const currElment = el.getBoundingClientRect()
          const body = document.body.getBoundingClientRect()
          if (x + currElment.width > body.width) {
            x = x - currElment.width
          }
          if (y + currElment.height > body.height) {
            y = y - currElment.height
          }

          if (y < 0) {
            y = 0
          }

          el.style.left = x + 'px'
          el.style.top = y + 'px'
        }
      }
    })
  }
}
